if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          mobileThumbnails: document.querySelector('[id^="MobileThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 1024px)");

        this.mobileThumbnailScrolling = false;

        if (this.elements.mobileThumbnails) {
          document.addEventListener("slideChanged", (e) =>
            this.onSlideChangedMobile(e)
          );
        
          const viewer = this.elements.viewer;
          const slider = viewer.querySelector('[id^="Slider-Gallery"]');
        
          this.elements.mobileThumbnails
            .querySelectorAll(".mobileThumbnail--button")
            .forEach((element) => {
              const variantOrder = element.dataset.variantOrder || 0;
              const mediaId = element.dataset.mediaId;
              const variantId = element.dataset.variantId;
              if (!slider || !mediaId) return;
              element.addEventListener("click", (event) => {
                this.handleMobileThumbnailClick(
                  event,
                  element,
                  mediaId,
                  parseInt(variantOrder),
                  variantId,
                  slider,
                  viewer
                );
              });
            });
        }
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      handleMobileThumbnailClick(event, element, mediaId, variantOrder, variantId, slider, viewer) {
        event.preventDefault();
        const isCustomTemplate = document.querySelector('.eva-custom-product-container') !== null;
      
        const mediaItems = isCustomTemplate
          ? Array.from(viewer.querySelectorAll(`[data-media-id="${mediaId}"].variant-slide--mobile`))
          : Array.from(viewer.querySelectorAll(`[data-media-id="${mediaId}"]`));
      
        if (!mediaItems.length) return;
      
        const currentMedia = mediaItems[variantOrder];
        if (!currentMedia) return;
        this.scrollToMedia(slider, currentMedia);
      }
      
      scrollToMedia(slider, targetMedia) {
        const sliderWidth = slider.clientWidth;
        const sliderMaxScroll = slider.scrollWidth - sliderWidth;
        const currentScrollLeft = slider.scrollLeft;
        
        const mediaLeft = targetMedia.offsetLeft;
        const mediaWidth = targetMedia.offsetWidth;
        const mediaRight = mediaLeft + mediaWidth;

        const visibleLeft = currentScrollLeft;
        const visibleRight = currentScrollLeft + sliderWidth;
        
        let targetScrollLeft = currentScrollLeft;
        let shouldScroll = false;
  
        const isFullyVisible = mediaLeft >= visibleLeft && mediaRight <= visibleRight;
        
        if (!isFullyVisible) {
    
          const mediaCenter = mediaLeft + (mediaWidth / 2);
          const visibleCenter = visibleLeft + (sliderWidth / 2);
          
          if (mediaCenter < visibleCenter) {

            targetScrollLeft = Math.max(0, mediaLeft - 20);
            shouldScroll = true;
          } else {
         
            targetScrollLeft = Math.min(sliderMaxScroll, mediaRight - sliderWidth + 20);
            shouldScroll = true;
          }
        } 
        
        if (shouldScroll) {
          slider.scrollTo({ 
            left: targetScrollLeft, 
            behavior: 'smooth' 
          });
          
          // Debug logging
          setTimeout(() => {
          }, 100);
        }
      }
      
      onSlideChangedMobile(event) {
        if (!event.detail?.currentPage || this.mobileThumbnailScrolling) return;

        const thumbnail = document.querySelectorAll(
          `[id^="MobileThumbnails"] button.is-active:not(.addon-hidden)`
        )[event.detail.currentPage - 1];

        if (!thumbnail) return;

        document
          .querySelectorAll(`[id^="MobileThumbnails"] button.active`)
          .forEach((b) => b.classList.remove("active"));

        thumbnail.classList.add("active");

        this.mobileThumbnailScrolling = true;
        const thumbnailContainer = document.querySelector(`[id^="MobileThumbnails"]`);
        if (thumbnailContainer) {
          const containerWidth = thumbnailContainer.clientWidth;
          const thumbnailLeft = thumbnail.offsetLeft;
          const thumbnailWidth = thumbnail.offsetWidth;
          const thumbnailRight = thumbnailLeft + thumbnailWidth;

          let scrollPosition;
          if (event.detail.currentPage === 1) {
            scrollPosition = 0;
          } else {
            scrollPosition = Math.max(0, thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2));
          }
          
          thumbnailContainer.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }

        setTimeout(() => {
          this.mobileThumbnailScrolling = false;
        }, 100);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelectorAll(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        activeMedia.forEach((element) => {
          element.classList.add("is-active");
        });

        if (prepend) {
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (window.innerWidth < 1024) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }

          if (
            (activeMedia[0] && !this.elements.thumbnails) ||
            (activeMedia[0] && this.dataset.desktopLayout === "stacked")
          ) {
            activeMedia[0].scrollIntoView({ behavior: "smooth" });
          }
        });

        activeMedia.forEach((el) => {
          this.playActiveMedia(el);
        });

        if (this.elements.mobileThumbnails) {
          this.elements.mobileThumbnails
            .querySelectorAll("[data-media-id]")
            .forEach((element) => {
              element.classList.remove("is-active");
            });
          this.elements.mobileThumbnails
            .querySelectorAll(`[data-media-id="${mediaId}"]`)
            .forEach((element) => {
              element.classList.add("is-active");
            });
          
          // Improved slider reset logic
          const slider = this.elements.viewer.querySelector(
            '[id^="Slider-Gallery"]'
          );
          if (slider) {
            // Find the active media and scroll to it properly
            const activeMediaElement = activeMedia[0];
            if (activeMediaElement) {
              setTimeout(() => {
                this.scrollToMedia(slider, activeMediaElement);
              }, 100);
            }
          }
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
          behavior: "smooth",
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}